import { Storage } from '@/enums/storage.enum';
import { loadLanguageAsync } from '@/i18n';
import { notificationsMixin } from '@/mixins/notifications';
import { profileResource } from '@/resources/profile.resource';
import { getProfileId } from '@/utils/profile';

/**
 * Mixin obsługi wersji językowych
 * Zawiera metody:
 *  - `getLabel(value)` - Zwraca na podstawie kodu języka obiekt z nazwą języka
 *  - `setLang(value)` - Ładuje i ustawia język interfejsu
 */
export const lagnuagesMixin = {
  mixins: [notificationsMixin],
  data() {
    return {
      languages: { selected: {}, list: [{ value: 'pl', label: 'Polski' }, { value: 'en', label: 'English' }] }
    };
  },
  mounted() {
    const lang = localStorage.getItem(Storage.LANG) || 'pl';

    loadLanguageAsync(lang);
    this.$set(this.languages, 'selected', this.getLabel(lang));
  },

  methods: {
    // @vuese
    // Zwraca na podstawie kodu języka obiekt z nazwą języka
    // @arg `value` - kod języka
    getLabel(value) {
      return { value, label: this.languages.list.find(lang => lang.value === value).label };
    },
    // @vuese
    // Ładuje i ustawia język interfejsu
    // @arg `value` - kod języka
    setLang(value) {
      loadLanguageAsync(value);
      this.$store.commit('system/setLanguage', value);
      this.$set(this.languages, 'selected', this.getLabel(value));
      const profileId = getProfileId();
      if (profileId) {
        profileResource
          .langUpdate(profileId, value)
          .then(res => (!res && this.notifyError('messages.lang.updateError')))
          .catch(() => this.notifyError('messages.lang.updateError'));
      }
    }
  }
};
